export default "__VITE_ASSET__5e454fef__"